import { AggregateType, ColumnType, DateRangeType, OptionalColumnEnum } from "../../enums/DRCXEnums";
import { NumericalFunctionEnum } from "../../enums/NumericalFunctionEnum";

export function parseColumnEquatableKey(equatableKey: string): {
    columnType: ColumnType | undefined;
    // columnType === ColumnType.Optional
    optionalColumn: OptionalColumnEnum | undefined;
    key: string | undefined;
    // columnType === ColumnType.Tat
    tagAssociationTypeID: number | undefined;
    // columnType === ColumnType.TatType
    tatTypeID: number | undefined;
    // columnType === ColumnType.Tat || columnType === ColumnType.TatType
    dataType: number | undefined;
    groupingTimeframe: number | undefined;
    groupingFunction: number | undefined;
    aggregationType: AggregateType | undefined;
    aggregationPeriod: number | undefined;
    aggregationFunction: NumericalFunctionEnum | undefined;
    aggregationStepDateRange: DateRangeType | undefined;
    aggregationStep: number | undefined;
    // columnType === ColumnType.Event
    eventColumn: number | undefined;
} {
    const components: string[] = equatableKey.split(":");
    const columnType = components.length > 0 && components[0].length > 0 ? Number(components[0]) as ColumnType : undefined;

    return {
        columnType,
        // columnType === ColumnType.Optional
        optionalColumn: columnType === ColumnType.Optional && components.length > 1 && components[1].length > 0 ? Number(components[1]) as OptionalColumnEnum : undefined,
        key: columnType === ColumnType.Optional && components.length > 2 && components[2].length > 0 ? components[2] : undefined,
        // columnType === ColumnType.Tat
        tagAssociationTypeID: columnType === ColumnType.Tat && components.length > 1 && components[1].length > 0 ? Number(components[1]) : undefined,
        // columnType === ColumnType.TatType
        tatTypeID: columnType === ColumnType.TatType && components.length > 1 && components[1].length > 0 ? Number(components[1]) : undefined,
        // columnType === ColumnType.Tat || columnType === ColumnType.TatType
        dataType: (columnType === ColumnType.Tat || columnType === ColumnType.TatType) && components.length > 2 && components[2].length > 0 ? Number(components[2]) : undefined,
        groupingTimeframe: (columnType === ColumnType.Tat || columnType === ColumnType.TatType) && components.length > 3 && components[3].length > 0 ? Number(components[3]) : undefined,
        groupingFunction: (columnType === ColumnType.Tat || columnType === ColumnType.TatType) && components.length > 4 && components[4].length > 0 ? Number(components[4]) : undefined,

        aggregationType: (columnType === ColumnType.Tat || columnType === ColumnType.TatType) && components.length > 5 && components[5].length > 0 ? Number(components[5]) as AggregateType : undefined,
        
        aggregationPeriod: (columnType === ColumnType.Tat || columnType === ColumnType.TatType) && components.length > 6 && components[6].length > 0 ? Number(components[6]) : undefined,
        aggregationFunction: (columnType === ColumnType.Tat || columnType === ColumnType.TatType) && components.length > 7 && components[7].length > 0 ? Number(components[7]) as NumericalFunctionEnum : undefined,
        aggregationStepDateRange: (columnType === ColumnType.Tat || columnType === ColumnType.TatType) && components.length > 8 && components[8].length > 0 ? Number(components[8]) as DateRangeType : undefined,
        aggregationStep: (columnType === ColumnType.Tat || columnType === ColumnType.TatType) && components.length > 9 && components[9].length > 0 ? Number(components[9]) : undefined,
        // columnType === ColumnType.Event
        eventColumn: columnType === ColumnType.Event && components.length > 1 && components[1].length > 0 ? Number(components[1]) : undefined
    };
}